export default __webpack_public_path__ + "static/media/ht-1.cab71ae7.svg";